// src/features/Dicom/EncephalonSection.styled.ts
import styled, { keyframes } from 'styled-components';
import { panel, panelHeader, panelTitle, primaryButton } from 'components/explore/consoleStyled';

export const EncephalonContainer = styled.div`
  ${panel}
  margin-bottom: 0;
`;

export const EncephalonHeaderRow = styled.div`
  ${panelHeader}
`;

export const EncephalonLabel = styled.div`
  ${panelTitle}
`;

export const StudyButton = styled.button`
  ${primaryButton}
`;

export const ErrorMessage = styled.div`
  color: var(--bad);
  background: rgba(255, 93, 108, 0.1);
  padding: 6px 10px;
  border-radius: 6px;
  margin-bottom: 10px;
  font-size: 12.5px;
`;

// Add this to your EncephalonSection.styled.ts
export const ScanSectionWrapper = styled.div`
  margin-top: 1rem;
`;

// Spinner animation
const spin = keyframes`
  0% { transform: rotate(0deg);}
  100% { transform: rotate(360deg);}
`;

export const LoadingSpinner = styled.div`
  border: 3px solid var(--line);
  border-top: 3px solid var(--accent);
  border-radius: 50%;
  width: 28px;
  height: 28px;
  animation: ${spin} 1s linear infinite;
  margin: 0 auto;
`;

export const LoadingMessage = styled.div`
  margin-top: 8px;
  color: var(--ink-2);
  font-size: 13px;
  text-align: center;
`;
